import { defineComponent as _defineComponent } from 'vue'
import WidgetFactory from '@/models/Charts/widgetFactory';
import { ChartGenerator } from '@/models/Charts/abstract/chartGenerator';
import { CutStatesIntradayData } from '@/models/Charts/chartsData';
import CutStatesIntradayGenerator from '@/models/Charts/cutStatesIntradayGenerator';
import { FilterTimeSpanEnum } from '@/models/enums/FilterTimeSpanEnum';
import { DetailedViewEnum } from '@/models/enums/WidgetEnum';
import { isEmpty } from '@/utils/misc';
import { EChartsOption } from 'echarts';
import { devicesService } from '@/services/devices.service';
import { customersService } from '@/services/tenants.service';
import { useI18n } from '@/composables/i18n';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'CutStatesIntraday',
  props: {
    selectedDeviceIds: null,
    selectedShifts: null
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props as {
  selectedDeviceIds: string[];
  selectedShifts: number[];
};



const { t } = useI18n();



const data = ref<Record<string, CutStatesIntradayData[]>>({});
const options = ref<any[]>([]);
const omittedStates = ref<string[]>([]);
const noData = ref(false);
const loading = ref(false);

const customerIdDh = computed<number>(
  () => customersService.store.currentIdDh()!,
);

const generator: ChartGenerator<CutStatesIntradayData[]> =
  WidgetFactory.createGenerator(
    DetailedViewEnum.CutStatesIntraday,
    customerIdDh.value,
  );

onMounted(async () => {
  await update();
});

async function update() {
  loading.value = true;
  noData.value = false;
  options.value = new Array(deviceIds.value.length);
  Promise.all(
    deviceIds.value.map(async (deviceid) => {
      const newData = await generator.getData(
        [deviceid],
        props.selectedShifts,
        FilterTimeSpanEnum.Day,
      );

      if (!isEmpty(newData)) {
        data.value[deviceid] = newData!;
        return updateOptions(deviceid);
      } else {
        noData.value = true;
      }
    }),
  )
    .then((newOptions) => (options.value = newOptions))
    .finally(() => (loading.value = false));
}

function updateOptions(deviceId: string): EChartsOption {
  const newData = data.value[deviceId] === null ? [] : data.value[deviceId];
  const params = {
    device: getDeviceName(deviceId),
    omittedStates: omittedStates.value,
  };
  return generator.updateOptions(newData, params);
}

function getDeviceName(deviceId: string): string {
  return devicesService.store.getNameByStringId(deviceId)!;
}

function onLegendChange({ name }: any) {
  if (omittedStates.value.includes(name)) {
    omittedStates.value = [
      ...omittedStates.value.filter((state) => state !== name),
    ];
  } else {
    omittedStates.value = [...omittedStates.value, name];
  }
  options.value = deviceIds.value.map((deviceId) => updateOptions(deviceId));
}

const deviceIds = computed<string[]>(() => {
  if (isEmpty(props.selectedDeviceIds)) {
    return devicesService.store.getAllCutDevicesIds();
  }
  return props.selectedDeviceIds;
});

const legendOption = computed(() => {
  const legendGenerator = WidgetFactory.createGenerator(
    DetailedViewEnum.CutStatesIntraday,
    customerIdDh.value,
  )! as CutStatesIntradayGenerator;
  return legendGenerator.updateLegend();
});

onBeforeUnmount(() => {
  generator?.abort();
});

return { __sfc: true,props, t, emit, data, options, omittedStates, noData, loading, customerIdDh, generator, update, updateOptions, getDeviceName, onLegendChange, deviceIds, legendOption, isEmpty }
}

})